
  import { InspectionRecord } from '@/entities/inspection';
  import { getPagination as getInspectionPagination, list as getInspectionList } from '@/services/api/resources/inspection';
  import Widget, { CollapsibleProperties } from '@/ui/components/home/Widget.vue';
  import StaticPagination from '@/ui/components/StaticPagination.vue';
  import { ResourceTable } from '@/ui/components/table/ResourceTable';
  import { Tag } from '@/ui/components/Tag';
  import { useLazyPagination, useTask } from '@/ui/concerns';
  import { useSubmittedForm } from '@/ui/concerns/useSubmittedForm';
  import { useQueries } from '@/ui/pages/dashboard/useQueries';
  import { router } from '@/ui/routes';
  import { defineComponent, ref, watch } from 'vue';
  import { Loader } from '@/ui/components/Loader';

  const INSPECTIONS_COUNT = 5;

  export default defineComponent<CollapsibleProperties>({
    components: {
      Widget,
      Loader,
      ResourceTable,
      Pagination: StaticPagination,
      Tag,
    },
    props: ['collapsible'],
    setup() {
      const inspections = ref<InspectionRecord[]>([]);
      const page = ref(1);
      const isEmpty = ref(false);

      const { recentlyDoneInspectionsQuery } = useQueries();
      const getTodosPagination = () => getInspectionPagination(recentlyDoneInspectionsQuery());
      const { total, totalLoading, updateLazyPaginationOnDataFetch } = useLazyPagination(getTodosPagination);
      const { getConductedAt } = useSubmittedForm();

      const getInspections = useTask(
        () => getInspectionList(recentlyDoneInspectionsQuery({
          page: page.value,
          perPage: INSPECTIONS_COUNT,
        })),
        response => {
          inspections.value = response.data;
          isEmpty.value = inspections.value.length === 0;

          updateLazyPaginationOnDataFetch(response, INSPECTIONS_COUNT);
        },
      );

      const onPageChanged = (value: number) => {
        page.value = value;
      };

      watch([page], () => getInspections.run({ page: page.value }));

      const openInspection = (inspection: InspectionRecord) => {
        const id = String(inspection.data.inspection.id);

        router.push({ name: 'inspectionDetail', params: { id } });
      };

      const getDoneByName = (inspection: InspectionRecord) => inspection.data.doneBy?.data?.name;

      return {
        getInspections,
        inspections,
        page,
        perPage: INSPECTIONS_COUNT,
        total,
        totalLoading,
        onPageChanged,
        openInspection,
        getDoneByName,
        isEmpty,
        getConductedAt,
      };
    },
  });
